<template>
	<v-easy-dialog v-model="isOpen">
		<div class="recommend">
			<button class="recommend__close" @click="$emit('closePopup')">
				<img src="@/assets/icons/cross.svg" alt="x" />
			</button>
			<span>Recommend skin concierge</span>
			<a href="#" class="recommend__link picto_line"
			><span class="picto_line__text recommend__link__text"
				>e-mail
				</span>
				<img
					svg-inline
					class="picto_line__picto"
					src="@/assets/icons/email.svg"
				/></a>
			<a href="#" class="recommend__link picto_line"
			><span class="picto_line__text recommend__link__text"
				>instagram
				</span>
				<img
					svg-inline
					class="picto_line__picto"
					src="@/assets/icons/instagram.svg"
				/></a>
			<a href="#" class="recommend__link picto_line"
			><span class="picto_line__text recommend__link__text"
				>whatsapp
				</span>
				<img
					svg-inline
					class="picto_line__picto"
					src="@/assets/icons/whatsapp.svg"
				/></a>
			<a href="#" class="recommend__link picto_line"
			><span class="picto_line__text recommend__link__text"
				>copy link
				</span>
				<img
					svg-inline
					class="picto_line__picto"
					src="@/assets/icons/link.svg"
				/></a>
		</div>
	</v-easy-dialog>
</template>

<style lang="sass">
.recommend
  padding: 55px
  padding-left: 335px
  background:
    color: var(--light-grey)
    image: url(/img/portraits/portrait-recommend.png)
    repeat: no-repeat
    size: contain
  font-family: var(--font-family-label)
  font-style: normal
  font-weight: 400
  font-size: 18px
  line-height: 24px
  text:
    align: center
  display: flex
  flex-direction: column
  position: relative
  &__close
    position: absolute
    top: 16px
    right: 16px
    background: none
    border: none
    cursor: pointer
  &__link
    width: 100%
    align-items: center
    color: var(--black)
    opacity: 0.5
    transition: opacity 0.3s ease
    will-change: opacity
    text-decoration: none
    margin-top: 20px !important
    &:visited
      color: var(--black)
    &:hover
      opacity: 1
    .svg--secondary__fill
      fill: var(--light-grey)
    .svg--secondary_stroke
      stroke: var(--light-grey)

    @media screen and (min-width: 64em)
      &__text
        width: 35% !important

  @media screen and (max-width: 64em)
    font-size: var(--font-size-tiny)
    padding-left: initial
    padding: 20px 40px
    background-position: -120px

.v-easy-dialog--backdrop-btn
  background-color: transparent
.v-easy-dialog--content-container
  width: auto!important
</style>

<script>
import VEasyDialog from 'v-easy-dialog'

export default {
	components: {
		VEasyDialog
	},
	emits: ['closePopup'],
	props: {
		isOpen: {
			type: Boolean,
			default: false
		}
	},
	methods: {}
}
</script>
